const PROJECTS_SORT_TYPES = {
  ASCENDING: 0,
  DESCENDING: 1,
};

const PROJECTS_SORT_KEYS = {
  TOKEN_PROJECT_NAME: 0,
  TOKEN_SYMBOL: 1,
  TOKEN_PRICE_IN_MERX: 2,
  TOKEN_PRICE_IN_USD: 3,
  TOTAL_RAISED: 4,
  TARGET_RAISED: 5,
  TOTAL_TOKEN_SOLD: 6,
  DISTRIBUTION: 7,
  TOTAL_SUPPLY: 8,
  STATUS: 9,
};

const NFT_PROJECTS_SORT_KEYS = {
  NFT_NAME: 0,
  NFT_URL: 1,
  NFT_ADDRESS: 2,
  NFT_PRICE_IN_MERX: 3,
  NFT_PRICE_IN_USD: 4,
  DISTRIBUTION: 5,
  TOTAL_SUPPLY: 6,
  CURRENT_PRICE: 7,
  ALL_TIME_HIGH: 8,
  STATUS: 9,
};

const sortTypes = [
  {
    name: 'Ascending',
    icon: 'BiSortUp',
  },
  {
    name: 'Descending',
    icon: 'BiSortDown',
  },
];

const getTokenProjectAsset = (project) => project?.token || {};
const getNftProjectAsset = (project) => project?.nft || {};

const sortKeys = [
  {
    name: 'Token Project Name',
    type: 'string',
    getValue: (project) => project?.name,
    defaultSortType: PROJECTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Token Symbol',
    type: 'string',
    getValue: (project) => getTokenProjectAsset(project)?.symbol,
    defaultSortType: PROJECTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Token Price in MERX',
    type: 'number',
    getValue: (project) => getTokenProjectAsset(project)?.price_in_mercurx,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Token Price in USD',
    type: 'number',
    getValue: (project) => getTokenProjectAsset(project)?.price_in_usd,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Total Raised',
    type: 'number',
    getValue: (project) => project?.total_raised,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Target Raised',
    type: 'number',
    getValue: (project) => project?.target_raised,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Total Token Sold',
    type: 'number',
    getValue: (project) => project?.total_tokens_sold,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Distribution',
    type: 'number',
    getValue: (project) => getTokenProjectAsset(project)?.distribution,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Total Supply',
    type: 'number',
    getValue: (project) => getTokenProjectAsset(project)?.total_supply,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Status',
    type: 'string',
    getValue: (project) => project?.is_active,
    defaultSortType: PROJECTS_SORT_TYPES.ASCENDING,
  },
];

const nftSortKeys = [
  {
    name: 'NFT Name',
    type: 'string',
    getValue: (project) => getNftProjectAsset(project)?.name,
    defaultSortType: PROJECTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'NFT URL',
    type: 'string',
    getValue: (project) => getNftProjectAsset(project)?.url,
    defaultSortType: PROJECTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'NFT Address',
    type: 'string',
    getValue: (project) => getNftProjectAsset(project)?.address,
    defaultSortType: PROJECTS_SORT_TYPES.ASCENDING,
  },
  {
    name: 'NFT Price in MERX',
    type: 'number',
    getValue: (project) => getNftProjectAsset(project)?.price_in_mercurx,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'NFT Price in USD',
    type: 'number',
    getValue: (project) => getNftProjectAsset(project)?.price_in_usd,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Distribution',
    type: 'number',
    getValue: (project) => getNftProjectAsset(project)?.distribution,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Total Supply',
    type: 'number',
    getValue: (project) => getNftProjectAsset(project)?.total_supply,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Current Price',
    type: 'number',
    getValue: (project) => getNftProjectAsset(project)?.current_price,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'All Time High',
    type: 'number',
    getValue: (project) => getNftProjectAsset(project)?.all_time_high,
    defaultSortType: PROJECTS_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Status',
    type: 'string',
    getValue: (project) => project?.is_active,
    defaultSortType: PROJECTS_SORT_TYPES.ASCENDING,
  },
];

const projectsQuickFilterConstants = {
  ALL: 1,
  ACTIVE: 2,
  COMPLETED: 3,
};

export {
  PROJECTS_SORT_KEYS,
  NFT_PROJECTS_SORT_KEYS,
  PROJECTS_SORT_TYPES,
  sortTypes,
  sortKeys,
  nftSortKeys,
  projectsQuickFilterConstants,
};
